import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 174 153",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 174 153\" id=\"icon-windows\"><path d=\"m170.41,21.125c-32.996,13.642-48.861,5.973-63.16-3.65l-16.278,56.462c14.285,9.678,31.531,17.635,63.188,3.463l16.25-56.275z\" style=\"fill:#91c300;\" /><path style=\"fill:#00b4f1;\" d=\"m63.142,134.63c-14.331-9.645-29.91-17.578-62.984-3.902l16.195-56.568c33.081-13.678,48.973-5.938,63.29,3.766l-16.501,56.703z\" /><path d=\"m82.393,67.715c-8.628-5.81-17.907-11.233-31.085-11.333-8.695-0.067-19.045,2.403-32.184,7.836l16.283-56.422c33.059-13.669,48.938-5.933,63.245,3.764l-16.259,56.155z\" style=\"fill:#f8682c;\" /><path d=\"m88.227,83.369c14.313,9.637,30.212,17.313,63.243,3.66l-16.281,56.234c-33.037,13.664-48.903,5.926-63.201-3.77l16.239-56.124z\" style=\"fill:#ffc300;\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uas/windows.svg
// module id = vURw
// module chunks = 16